<div class="row">
  <div class="col-sm-6 col-cake-count">
    <div>
      <ui-cake-counter
        [size]="'md'"
        [extraCount]="extraCount"
        [count]="cartLine.count"
        [step]="cartLine.size?.details.pieces ? cartLine.productType.increment: 1"
        [minCount]="cartLine.size?.details.pieces ? cartLine.productType.minQuantity: 1"
        [maxCount]="maxCount"
        [btnHighlighting]="true"
        [isMinusDisabled]="disabled"
        [isPlusDisabled]="disabled"
        [isAllowEnterCounter]="true"
        (onCountUpdated)="cartLine.count = $event; onLineUpdated.emit(cartLine);"
      ></ui-cake-counter>

      <ng-content></ng-content>
    </div>
  </div>
  <div class="col-sm-6 col-total">
    <cake-total
      class="d-block mt-sm-max-2"
      [extraPrice]="extraPrice"
      [cartLine]="cartLine"
      [currency]="currency"
      [disabled]="disabled"
      [discount]="discount"
    ></cake-total>
  </div>
</div>
